import gql from 'graphql-tag'

const getWebsiteFiltersQuery = gql`
  query getFilters($websiteId: ID) {
    filters(websiteId: $websiteId) {
      _id
      filterName
      type
    }
  }
`

export default getWebsiteFiltersQuery
